import React, {Component} from 'react'
import { Form } from 'react-bootstrap'
// import axios from 'axios';

export default class RemoteSelect extends Component {
    constructor(props) {
        super (props);

        this.state = {
            options: this.props.options,
            value: this.props.value
        }

        this.fieldToMap = this.props.fieldToMap ? this.props.fieldToMap : "name";
    }

    static dataAdapter(data, fieldToMap = "id") {
        const options = [];

        if(fieldToMap && fieldToMap.length > 0) {
            for (const x of data) {
                options[x[fieldToMap]] = x;
            }
        }

        return options;
    }

    componentDidMount() {
        // if(this.props.options !== undefined) {
        //     this.setState({
        //         options: this.props.options,
        //         value: ""
        //     });
        // } else if(this.props.url !== undefined) {
        //     console.log(this.props.url);
        //     const t = this;

        //     axios.get(this.props.url, { headers: { Authorization: Auth.bearer } })
        //         .then(response => {
        //             //console.log(response);
        //             console.log(this.props.value);

        //             t.setState({
        //                 options: response.data.data,
        //                 value: this.props.value
        //             });
        //         })
        //         .catch((error) => {
        //             console.log('error ' + error);
        //         });
        // } else {
        //     this.setState({
        //         value: this.props.value
        //     });
        // }
    }

    componentDidUpdate(prevProps) {
        if (this.props.options !== prevProps.options) {
            this.setState({
                options: this.props.options
            });
        }
      }

    handleChange = (e) => {
        // const value = parseInt(e.target.value, 10);
        const value = e.target.value;

        this.setState({
            value: value
        });

        if(this.props.onChange !== undefined)
            this.props.onChange(e, value);

        if(this.props.onChange2 !== undefined)
            this.props.onChange2(e, value);
    }

    render() {
        let key = 0;

        const options = (!this.state.options) ? [] : 
            this.state.options.map(o => 
                <option key={key++} value={o.id} defaultValue={this.state.value === o.id}>{o[this.fieldToMap]}</option>
            );
        const isDisabled = this.state.options === null || this.props.disabled;
        const nullOption = (this.props.nullOption === true) ? <option value={null}></option> : "";
        const c = (this.props.className) ? this.props.className : "form-control";

        return (
            <Form.Control as="select" name={this.props.name} value={this.state.value} 
                disabled={isDisabled} className={c} onChange={this.handleChange}>
                {nullOption}
                {options}
            </Form.Control>);
    }
}